import { z } from 'zod';
import { dataGridSearchFields } from '@/features/dynamic-table';
import { FilterKey, TabKey } from './-constants';
import type { SortableFieldKey } from './-query/type';
export const SearchSchema = z.object({
  ...dataGridSearchFields,
  sortColumn: z.custom<SortableFieldKey>(v => typeof v === 'string').optional(),
  menu: z.nativeEnum(TabKey).default(TabKey.EMPLOYEE),
  category: z.nativeEnum(FilterKey).default(FilterKey.EMPLOYEE_ALL),
  departmentIdIn: z.array(z.string()).optional(),
  workerTypeIn: z.array(z.string()).optional(),
  placeIdIn: z.array(z.string()).optional(),
  freeText: z.string().optional()
});
export type SearchSchema = z.infer<typeof SearchSchema>;